export const BETA_FEATURES = { SHIPPING_PROTECTION_PAGE: 'insurance_page_experiment' }
